import { Box, Typography } from "@mui/material";

interface RequestDaysCard {
    cardColor: string;
    cardType: string;
    daysUsed?: string;
    daysWaiting?: string;
    daysAvailable?: string;
    untilDate?: string;
    thisYear?: string;
}

const RequestDaysCard = ({
    cardColor,
    cardType,
    daysAvailable,
}: RequestDaysCard) => {
    return (
        <Box
            sx={{
                backgroundColor: cardColor,
                width: "120px",
                height: "120px",
                mr: 2,
                borderRadius: "10px",
                p: 1,
            }}
        >
            <Box sx={{ p: 1 }}>
                <Typography
                    sx={{ m: 0 }}
                    variant="h4"
                    fontWeight="bold"
                    mb="4px"
                    color="#3B3B3B"
                >
                    {daysAvailable}
                </Typography>
                <Typography
                    sx={{ m: 0 }}
                    variant="subtitle2"
                    fontWeight="bold"
                    mb="4px"
                    color="#3B3B3B"
                >
                    {cardType === "workingDays"
                        ? "WORKING DAYS"
                        : "CALENDAR DAYS"}
                </Typography>
            </Box>
        </Box>
    );
};

export default RequestDaysCard;
